<ng-container *ngIf="isLoading() === false">
  <div class="confirm-dialog-close">
    <qpoint-icon (click)="dismiss()" icon="times"></qpoint-icon>
  </div>
  <div class="confirm-dialog-header" *ngIf="title">
    <qpoint-icon *ngIf="confirmDialogType === 'warning'" [icon]="'exclamation-triangle'"></qpoint-icon>
    <qpoint-icon class="check" *ngIf="confirmDialogType === 'success'" icon="check" iconType="regular"></qpoint-icon>
    <qpoint-icon class="error" *ngIf="confirmDialogType === 'error'" [icon]="'exclamation-circle'"></qpoint-icon>
    <div [ngClass]="{'bold-text': message}" [innerHTML]="title | translate"></div>
  </div>

  <div class="confirm-dialog-body" *ngIf="message">
    <qpoint-icon *ngIf="!title && confirmDialogType != 'success'" [icon]="'exclamation-triangle'"></qpoint-icon>
    <qpoint-icon class="check" *ngIf="!title && confirmDialogType === 'success'" icon="check" iconType="regular"></qpoint-icon>
    <div [innerHTML]="message | translate"></div>
  </div>

  <div class="confirm-dialog-footer">
    <qpoint-button *ngFor="let button of (filteredButtons || []);index as i"
                   (buttonClicked)="buttonClicked(button, i)" [icon]="button.icon?.name"
                   [iconType]="button?.icon?.iconType" [iconVariant]="button?.icon?.iconVariant"
                   [variant]="button.variant">{{button.text | translate}}</qpoint-button>
  </div>
</ng-container>
